import { useEffect, useRef } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";

function Logout() {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const hasLoggedOut = useRef(false);

  // Run the logout in an effect — calling signOut() during render updates the Authenticator
  // provider mid-render and triggers React's setState-in-render warning. The full reload tears
  // the app down cleanly and resets all in-memory state.
  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;
    signOut();
    localStorage.clear();
    window.location.replace("/login");
  }, [signOut]);

  return null;
}

export default Logout;
